/**
 * Created by phatbass on 2/9/16.
 */

angular.module('far.fos_user')
    .controller('RegistrationController', function ($scope, $log, $http, $window, form, hideShowPassword, autocomplete, showModalMessage) {
        var vm = {
            fast: true,
            submitted: false,
            errors: [],
            form: {},
            valid: {},
            blur: {
                phone: false,
                email: false,
                plainPassword: false,
                first_name: false,
                last_name: false,
                middle_name: false
            },
            name: '',
            noMiddleName: false,
            autoCompleteSelect: {
                country: null,
                region: null,
                city: null
            },
            formRegistration: form('formRegistration'),
            setName: function (value) {
                vm.name = value;
            },
            hideShowPassword: hideShowPassword,
            submit: function () {
                if ( vm.submitted ) {
                    return false;
                }

                if ( !$scope.formRegistration.$valid ) {
                    Object.keys( vm.blur ).map(function( value ) {
                        vm.blur[ value ] = true;
                    });

                    return false;
                }

                vm.submitted = true;

                var data = {};

                data[vm.name] = angular.merge({}, vm.form);

                if (angular.isObject(data[vm.name].city)) {
                    data[vm.name].city = data[vm.name].city.name;
                }

                if (angular.isObject(data[vm.name].region)) {
                    data[vm.name].region = data[vm.name].region.name;
                }

                $http.post(Routing.generate('fos_user_registration_register'), data)
                    .then(function successCallback() {
                        $window.location.href = Routing.generate('fos_user_registration_check_email');
                    }, function errorCallback(response) {
                        vm.errors = [];

                        if (angular.isDefined(response.data.form) ) {
                            if (angular.isDefined(response.data.form.errors) ) {
                                response.data.form.errors.forEach(function (error) {
                                    vm.errors.push(error);
                                });
                            } else {
                                for ( var key in response.data.form.children ) {
                                    if ( response.data.form.children[key].errors ) {
                                        for ( var error in response.data.form.children[key].errors ) {
                                            vm.errors.push(response.data.form.children[key].errors[ error ]);
                                        }
                                    }
                                }
                            }
                        } else {
                            vm.errors.push('Ошибка на сервере. Попробуйте позже.');
                        }

                        showModalMessage(vm.errors.join(", "));

                        vm.submitted = false;
                    });
            }
        };

        vm.formRegistration
            .addField('country', 'uiSelect', {
                validators: {
                    required: true
                },
                options: {
                    onSelect: 'field.uiSelectOptions.onSelect($item, $model)',
                    class: 'form__ui-select width-350'
                },
                uiSelectOptions: {
                    matchTitle: '{{ $select.selected.name }} ',
                    choicesTitle: '{{ item.name }}',
                    match: {
                        placeholder: 'Страна',
                        allowClear: true
                    },
                    choices: {
                        repeat: 'item in field.items track by item.id',
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Country", "country")',
                        refreshDelay: 0
                    },
                    refreshAutoComplete: autocomplete.refreshAutoComplete,
                    onSelect: function( item ) {
                        if ( item ) {
                            vm.autoCompleteSelect.country = item.id;
                            vm.autoCompleteSelect.region = null;
                            vm.autoCompleteSelect.city = null;
                            vm.form.country = item.id;

                            vm.formRegistration.$fields.region.items = [];
                        }
                    }
                }
            }, autocomplete.get('country'))
            .addField('region', 'uiTypeahead', {
                validators: {
                    required: true
                },
                label: null,
                options: {
                    class: 'form__item',
                    placeholder: 'Регион',
                    tabindex: 10,
                    uibTypeahead: "row as row.name for row in field.refreshAutoComplete($viewValue, 'Region')"
                },
                fieldData: {
                    clearBtn: true,
                    refreshAutoComplete: function(name, term) {
                        return autocomplete.refreshAutoComplete(name, term, null, vm.autoCompleteSelect)
                    }
                }
            })
            .addField('city', 'uiTypeahead', {
                validators: {
                    required: true
                },
                label: null,
                options: {
                    class: 'form__item',
                    placeholder: 'Населенный пункт',
                    uibTypeahead: "row as row.name for row in field.refreshAutoComplete($viewValue, 'City')"
                },
                fieldData: {
                    clearBtn: true,
                    refreshAutoComplete: function(name, term) {

                        if (angular.isObject(vm.form.region)) {
                            vm.autoCompleteSelect.region = vm.form.region.id;
                        } else {
                            vm.autoCompleteSelect.region = null;
                        }

                        return autocomplete.refreshAutoComplete(name, term, null, vm.autoCompleteSelect)
                    }
                }
            })
            .addField('club', 'uiSelect', {
                validators: {
                    required: true
                },
                options: {
                    onSelect: 'field.uiSelectOptions.onSelect($item, $model)',
                    class: 'form__ui-select width-350'
                },
                uiSelectOptions: {
                    matchTitle: '{{ $select.selected.name }} ',
                    choicesTitle: '{{ item.name }}',
                    match: {
                        placeholder: 'Выберите клуб',
                        allowClear: true
                    },
                    choices: {
                        repeat: 'item in field.items track by item.id',
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Club", "club")',
                        refreshDelay: 0
                    },
                    refreshAutoComplete: autocomplete.refreshAutoComplete,
                    onSelect: function(item) {
                        vm.form.club = item ? item.id : null;
                    }
                }
            }, autocomplete.get('club'))
            .addField('middle_name', 'uiTypeahead', {
                validators: {
                    required: false
                },
                label: null,
                options: {
                    class: 'form__item',
                    placeholder: 'Отчество',
                    tabindex: 10,
                    uibTypeahead: "row as row.name for row in field.refreshAutoComplete($viewValue, 'MiddleName')"
                },
                fieldData: {
                    clearBtn: true,
                    refreshAutoComplete: function(name, term) {
                        return autocomplete.refreshAutoComplete(name, term, null, vm.autoCompleteSelect)
                    }
                }
            })
            .addField('no_middle_name', 'checkbox', {
                validators: {
                    required: false
                },
                options: {},
                label: 'Нет отчества'
            })
        ;

        return vm;
    });